import { useDesignMaxTheme, useModal } from "@/packages";
import { Alert } from "@components/alert";
import type { MaxPersonProps } from "../types";

export const useMaxPerson = ({ personOfCapacity }: MaxPersonProps) => {
    const { openModal, setModalContent, setIconName } = useModal();
    const { isMobile } = useDesignMaxTheme().MEDIAS();

    const handleMaxPerson = (e: React.MouseEvent<HTMLButtonElement>, personCountMap: Record<0 | 1 | 2, number>) => {
        const { currentTarget } = e;
        const isIncrement = currentTarget?.textContent === "+";
        const totalCount = personCountMap[0] + personCountMap[1] + personCountMap[2];

        if (isIncrement && totalCount === Number(personOfCapacity.max)) {
            openModal();
            setModalContent(<Alert>기준 최대인원 {personOfCapacity.max}인을 초과할 수 없습니다.</Alert>);
            if (!isMobile) setIconName("close");
        }
    };

    return { handleMaxPerson };
};
